import { render } from "./WhatsAppFlowPreview.vue?vue&type=template&id=8cd88ed6&scoped=true"
import script from "./WhatsAppFlowPreview.vue?vue&type=script&lang=js"
export * from "./WhatsAppFlowPreview.vue?vue&type=script&lang=js"

import "./WhatsAppFlowPreview.vue?vue&type=style&index=0&id=8cd88ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd88ed6"]])

export default __exports__